module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admininscripciones-evento-crear/admininscripciones-evento-crear.component.scss
// module id = ./src/app/admininscripciones-evento-crear/admininscripciones-evento-crear.component.scss
// module chunks = main